// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"12d07a58","96":"8fb21926","233":"0bd2f9e6","453":"04c79a43","469":"957b5120","906":"94db3d3e","997":"04127dca"}[chunkId] + ".chunk.js";
};